import { OpportunityReportsFiltersModels } from './../../../../models/opportunity-reports/opportunity-reports-filters.models';
import { OpportunityReportsStoreModels } from './opportunityReportsData.state';

export function getOpportunityReportsStoredData(opportunityReports: OpportunityReportsStoreModels[], reportType: string, addedFilters: OpportunityReportsFiltersModels){

    let results: {data: OpportunityReportsStoreModels|null, index: number} = {
        data: null,
        index: -1
    }

    const index = opportunityReports.findIndex(data=>data.reportType==reportType &&
        data.addedFilters.fromDateOnly==addedFilters.fromDateOnly &&
        data.addedFilters.toDateOnly==addedFilters.toDateOnly &&
        data.addedFilters.accountChannelId==addedFilters.accountChannelId &&
        data.addedFilters.opportunityChannelId==addedFilters.opportunityChannelId);

    if(index > -1){
        results.data = opportunityReports[index];
        results.index = index;
    }

    return results;

}
